import { ListGroup } from '../../../share/Components'
import { Icon, RaytebForm, TextBox } from '../../../share/Elements'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { useState } from 'react'
import { RecordEssentialInfoType } from '../../../models/ViewModels/RecordViewModel'
import { NULL } from 'sass'

const RecordEssentialInformation = ({
  item,
  onItemChange,
}: {
  item?: RecordEssentialInfoType
  onItemChange: (updatedItem: RecordEssentialInfoType) => void // A function to handle item changes
}) => {
  //const uniqueItems = Array.from(new Set(item?.items || []));
  const [essentialItems, setEssentials] = useState<RecordEssentialInfoType>({})
  const [essentialItem, setEssentialItem] = useState<string>('') // Track the value of the input field
  if (item?.items !== undefined) {
    const updatedItems = item?.items ? [...item.items] : []
    item?.items?.forEach((element) => {
      const itemIndex = item?.items?.findIndex(
        (obj) => obj.description === element.description
      )
      if (itemIndex !== -1) {
        // If the item exists, update its description
        //updatedItems[itemIndex].description = element.description;
      } else {
        // If the item doesn't exist, create a new item and add it to the array
        updatedItems.push({
          description: element.description,
        })
      }
      // setEssentials({
      //   ...essentialItems,
      //   items: updatedItems,
      // });
      // ChangeItems(updatedItems);
      // Call the onItemChange function with the updated item
      // onItemChange({
      //   ...items,
      //   items: updatedItems,
      // });
      //   });
    })
  }

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    //setEssential(event.target.value);
    // Create a copy of the items array (if it exists)
    // const updatedItems = essentialItems ? [...essentialItems] : [];
    // // Find the index of the item with a matching laboratoryServeId
    // const itemIndex = updatedItems.findIndex(
    //   (obj) => obj.description === event.target.value
    // );
    // if (itemIndex !== -1) {
    //   // If the item exists, update its description
    //   updatedItems[itemIndex].description = event.target.value;
    // } else {
    //   // If the item doesn't exist, create a new item and add it to the array
    //   updatedItems.push({
    //     description: event.target.value,
    //   });
    // }
    //ChangeItems(updatedItems);
    // Call the onItemChange function with the updated item
    // onItemChange({
    //   ...items,
    //   items: updatedItems,
    // });
  }
  function onAdded(e) {
    if (essentialItem === undefined || essentialItem === '') return
    const updatedItems = item?.items ? [...item.items] : []
    const itemIndex = updatedItems.findIndex(
      (obj) => obj.description === essentialItem
    )
    if (itemIndex !== -1) {
      // If the item exists, update its description
      updatedItems[itemIndex].description = essentialItem
    } else {
      // If the item doesn't exist, create a new item and add it to the array
      updatedItems.push({
        description: essentialItem,
      })
    }
    onItemChange({
      ...item,
      items: updatedItems,
    })
    setEssentials({
      ...essentialItems,
      items: updatedItems,
    })
    setEssentialItem('')
  }
  return (
    <>
      <>
        <div className={false ? 'p-3 hidden' : 'p-3'}>
          <ListGroup
            items={item?.items?.map((x) => ({
              title: x.description,
            }))}
          />

          <div className='flex justify-center items-center gap-6 mt-6'>
            <TextBox
              Type={TextBoxTypeEnum.Text}
              value={essentialItem}
              debounceTime={0}
              innerText='تایپ کنید ...'
              className='!border-0 focus:!border-0 focus:!ring-0 !border-b focus:!border-b h-8  rounded-none w-72'
              onChange={(e) => setEssentialItem(e.target.value)}
            // onChange={(e) => setEssentials({...essentialItems, essentialItems.push(e.target.value)})}
            />

            <div className='flex flex-col gap-2 justify-center items-center'>
              <Icon icon='rayteb-microphone' className='text-lg' />
              <Icon
                icon='rayteb-add-circular'
                className='text-lg'
                onClick={(e) => onAdded(e)}
              />
            </div>
          </div>
        </div>
      </>
    </>
  )
}

export default RecordEssentialInformation
